// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2DcDN","col":"CardReaderDesc_col__3TPrt","label":"CardReaderDesc_label__2N74c"};